import { TourType } from '../data/tour-config';

export enum TourProgressStatus {
  Completed = 1,
  Skipped = 2,
  Dismissed = 3,
}

export interface TourProgress {
  tourTypeId: TourType;
  seenVersion: number;
  tourProgressStatusTypeId: TourProgressStatus;
  /** Server-owned. Absent on an optimistic record that the server has not confirmed yet. */
  lastSeenOnUtc?: string;
}
